import { render, staticRenderFns } from "./batchInspectionAdminDispatch.vue?vue&type=template&id=1eb9fdde&scoped=true&"
import script from "./batchInspectionAdminDispatch.vue?vue&type=script&lang=js&"
export * from "./batchInspectionAdminDispatch.vue?vue&type=script&lang=js&"
import style0 from "./batchInspectionAdminDispatch.vue?vue&type=style&index=0&id=1eb9fdde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb9fdde",
  null
  
)

export default component.exports